module.exports = __webpack_public_path__ + "static/media/work_with_employers_icon.14342b14.svg";